var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRrDashboardInitial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 35,
    viewBox: "0 0 52 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2968 6.64402V2.02264H0.843262V34.3855H41.2968V32.3179C40.6022 32.2554 39.926 32.129 39.2741 31.9447V32.3628H2.86594V10.1134H33.2026L34.551 8.09067H2.86594V4.04532H39.2741V7.07926H40.0433C40.5067 7.07926 40.9461 6.92086 41.2968 6.64402ZM12.8371 12.3375L10.9369 13.0288L17.1629 30.1386L19.0632 29.4433L12.8371 12.3375ZM6.91129 16.1814V18.2041H8.93397V16.1814H6.91129ZM6.91129 24.2721V26.2948H8.93397V24.2721H6.91129Z",
    fill: "#0BB7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9202 28.3175C43.1932 28.3175 46.6569 24.8537 46.6569 20.5807C46.6569 16.3078 43.1932 12.844 38.9202 12.844C34.6473 12.844 31.1835 16.3078 31.1835 20.5807C31.1835 24.8537 34.6473 28.3175 38.9202 28.3175Z",
    stroke: "#0BB7A7",
    strokeWidth: 1.82041,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1058 10.1134H35.7344M45.2915 12.844L43.9262 14.2093",
    stroke: "#0BB7A7",
    strokeWidth: 1.82041,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0928 26.2948H29.1608",
    stroke: "#0BB7A7",
    strokeWidth: 2.02268,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0928 16.1814H29.1608",
    stroke: "#0BB7A7",
    strokeWidth: 2.02268,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5413 24.1588V23.3784L38.6382 23.2447V18.8481H37.5279V18.1035L39.9358 17.6665V23.2447L41.0327 23.3784V24.1588H37.5413Z",
    fill: "#0BB7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrDashboardInitial);
export default __webpack_public_path__ + "static/media/rr_dashboard_initial.3fd49efea4a68ecf54b8d881c93555f4.svg";
export { ForwardRef as ReactComponent };